<template>
    <svg
        class="svg svg--icon svg--reset"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
    >
        <title>Reset</title>
        <g>
            <polyline
                points="0.838 0.569 0.789 5.904 5.876 4.202"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
            ></polyline>
            <path
                d="M15.163,10.23A7.5,7.5,0,1,0,.8,5.9"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
            ></path>
            <path
                d="M5.352,15.019a7.488,7.488,0,0,1-2.177-1.277"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
            ></path>
            <path
                d="M10.281,15.147A7.507,7.507,0,0,1,8,15.5l-.172,0"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
            ></path>
            <path
                d="M14.168,12.268a7.553,7.553,0,0,1-1.678,1.74"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
            ></path>
            <path
                d="M1.574,11.869A7.448,7.448,0,0,1,.67,9.6"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
            ></path>
        </g>
    </svg>
</template>
